import { Slot } from '@radix-ui/react-slot'
import { type ComponentPropsWithRef, useMemo } from 'react'
import { cn } from '../../utils/cn.ts'
import type { WithDataAttributes } from '../componentProps.types.ts'
import {
  getIconContainerLayoutStyle,
  type GetIconContainerLayoutStyleProps,
} from './IconContainer.styles.ts'
import { useIconContainerOptionsContext } from './useIconContainerOptionsContext.ts'

export interface IconContainerProps
  extends ComponentPropsWithRef<'span'>,
    GetIconContainerLayoutStyleProps,
    WithDataAttributes {
  asChild?: boolean
}

/**
 * Controls icon sizes.
 */
export const IconContainer = (props: IconContainerProps) => {
  const {
    ref,
    asChild,
    className,
    size,
    context,
    withInnerPadding,
    children,
    ...restProps
  } = props

  const optionsContext = useIconContainerOptionsContext()

  const mergedSize = size ?? optionsContext.size
  const mergedContext = context ?? optionsContext.context
  const mergedWithInnerPadding =
    withInnerPadding ?? optionsContext.withInnerPadding

  const layoutClassName = useMemo(() => {
    return getIconContainerLayoutStyle({
      context: mergedContext,
      size: mergedSize,
      withInnerPadding: mergedWithInnerPadding,
    })
  }, [mergedContext, mergedSize, mergedWithInnerPadding])

  const Comp = asChild ? Slot : 'span'

  return (
    <Comp
      ref={ref}
      className={cn(layoutClassName, className, 'icon-container')}
      {...restProps}
    >
      {children}
    </Comp>
  )
}
